"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Request = _interopRequireDefault(require("./Request"));

var _StreamReader = _interopRequireDefault(require("./StreamReader"));

var _RequestError = _interopRequireDefault(require("./RequestError"));

var _ConnectionError = _interopRequireDefault(require("./ConnectionError"));

var _HTTPError = _interopRequireDefault(require("./HTTPError"));

var _ParseError = _interopRequireDefault(require("./ParseError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleRequest(method, url, options) {
  const request = new _Request.default(method, url, options);
  return request.run();
}

var _default = {
  trace: handleRequest.bind(null, 'TRACE'),
  head: handleRequest.bind(null, 'HEAD'),
  options: handleRequest.bind(null, 'OPTIONS'),
  get: handleRequest.bind(null, 'GET'),
  post: handleRequest.bind(null, 'POST'),
  put: handleRequest.bind(null, 'PUT'),
  patch: handleRequest.bind(null, 'PATCH'),
  del: handleRequest.bind(null, 'DELETE'),
  Request: _Request.default,
  StreamReader: _StreamReader.default,
  RequestError: _RequestError.default,
  ConnectionError: _ConnectionError.default,
  HTTPError: _HTTPError.default,
  ParseError: _ParseError.default
};
exports.default = _default;
module.exports = exports.default;
//# sourceMappingURL=index.js.map